import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

function isOverflown(element, digitsCheck, status, NormalMax, NormalMin, CautionMax, CautionMin, ActionMax, ActionMin) {
    return (
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth ||
        ((digitsCheck > 0 && element?.innerText?.length > digitsCheck) === true)
        || (
            ((status != null) === true)
        && (((NormalMax != null) === true)
        || ((NormalMin != null) === true)
        || ((CautionMax != null) === true)
        || ((CautionMin != null) === true)
        || ((ActionMax != null) === true)
        || ((ActionMin != null) === true)))
    );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {

    const { width, value, digitsCheck, status, NormalMax, NormalMin, CautionMax, CautionMin, ActionMax, ActionMin } = props;
    const wrapper = React.useRef(null);
    const cellDiv = React.useRef(null);
    const cellValue = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showFullCell, setShowFullCell] = React.useState(false);
    const [showPopper, setShowPopper] = React.useState(false);

    const handleMouseEnter = () => {
        const isCurrentlyOverflown = isOverflown(cellValue.current, digitsCheck, status, NormalMax, NormalMin, CautionMax, CautionMin, ActionMax, ActionMin);
        setShowPopper(isCurrentlyOverflown);
        setAnchorEl(cellDiv.current);
        setShowFullCell(true);
    };

    const handleMouseLeave = () => {
        setShowFullCell(false);
    };

    React.useEffect(() => {
        if (!showFullCell) {
            return undefined;
        }

        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
                setShowFullCell(false);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowFullCell, showFullCell]);

    return (
        <Box
            ref={wrapper}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                alignItems: 'center',
                lineHeight: '24px',
                width: '100%',
                height: '100%',
                position: 'relative',
                display: 'flex',
                zIndex: 99999999
            }}
        >
            <Box
                ref={cellDiv}
                sx={{
                    height: '100%',
                    width,
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    zIndex: 99999999
                }}
            />
            <Box
                ref={cellValue}
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', zIndex: 99999999 }}
            >
                {value}
            </Box>
            {showPopper && (
                <Popper
                    open={showFullCell && anchorEl !== null}
                    anchorEl={anchorEl}
                    style={{ width, marginLeft: -17, zIndex: 99999999 }}
                >
                    <Paper
                        elevation={1}
                        style={{ minHeight: wrapper.current.offsetHeight - 3, backgroundColor: "#6695F3", color: "#ffffff" }}
                    >
                        <Typography variant="body2" sx={{ padding: 1, overflowWrap: "break-word!important" }}>
                            {value}
                        </Typography>
                        {/* Aligned rows with | separator */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 4, fontFamily: "monospace" }}>
                            {(ActionMin != null || ActionMax != null) && status != null && (
                                <div style={{ display: "flex" }}>
                                    <Typography variant="body2" style={{ paddingLeft: 8, width: 100 }}>
                                        ActionMin: {ActionMin}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mr: 1, ml: 0, pl: 0 }}>|</Typography>
                                    <Typography variant="body2" style={{ width: 100 }}>
                                        ActionMax: {ActionMax}
                                    </Typography>
                                </div>
                            )}

                            {(CautionMin != null || CautionMax != null) && status != null && (
                                <div style={{ display: "flex" }}>
                                    <Typography variant="body2" style={{ paddingLeft: 8, width: 100 }}>
                                        CautionMin: {CautionMin}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mr: 1, ml: 0, pl: 0 }}>|</Typography>
                                    <Typography variant="body2" style={{ width: 100 }}>
                                        CautionMax: {CautionMax}
                                    </Typography>
                                </div>
                            )}

                            {(NormalMin != null || NormalMax != null) && status != null && (
                                <div style={{ display: "flex" }}>
                                    <Typography variant="body2" style={{ paddingLeft: 8, width: 100 }}>
                                        NormalMin: {NormalMin}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mr: 1, ml: 0, pl: 0 }}>|</Typography>
                                    <Typography variant="body2" style={{ width: 100 }}>
                                        NormalMax: {NormalMax}
                                    </Typography>
                                </div>
                            )}
                        </div>
                    </Paper>
                </Popper>
            )}
        </Box>
    );
});

export default function renderCellExpand(params) {
    var status = `${params?.field}Status`;
    const statusValue = params?.row?.[status]?.toLowerCase();
    const ActionMin = params?.row?.[`${params?.field}ActionMin`]
    const ActionMax = params?.row?.[`${params?.field}ActionMax`]
    const CautionMin = params?.row?.[`${params?.field}CautionMin`]
    const CautionMax = params?.row?.[`${params?.field}CautionMax`]
    const NormalMin = params?.row?.[`${params?.field}NormalMin`]
    const NormalMax = params?.row?.[`${params?.field}NormalMax`]
    return (
        <GridCellExpand value={params.value || ''} width={250} digitsCheck={params.digitsCheck}
            status={statusValue != undefined ? statusValue : null}
            ActionMin={ActionMin != undefined ? ActionMin : null}
            ActionMax={ActionMax != undefined ? ActionMax : null}
            CautionMin={CautionMin != undefined ? CautionMin : null}
            CautionMax={CautionMax != undefined ? CautionMax : null}
            NormalMin={NormalMin != undefined ? NormalMin : null}
            NormalMax={NormalMax != undefined ? NormalMax : null}

        />
    );
}